<template>
	<b-modal
		id="addnewfile"
		v-model="addnewfile"
		centered
		hide-footer
		title="Edit File"
		size="lg"
		no-close-on-backdrop
	>
		<b-overlay :show="showSpinner">
			<section class="position-absolute viewimage-header-icons mr-2">
				<img
					@click="$emit('close')"
					class="rotate-on-hover"
					src="@/assets/common/blue-cross.svg"
					alt=""
				/>
			</section>
			<div
				class="assetbank-tabs w-100 position-relative assetbank-modal-height"
			>
				<div class="mt-3">
					<Files
						v-if="addnewfile"
						:uploadlist="true"
						:fileData="fileData"
						:editFile="true"
						:selectedIndex="index"
						:validation="$v.fileData"
						:thumbnailPresent="thumbnailPresent"
						:uploadTime="uploadTime"
						:uploadfileExtension="'mp4'"
						:uploadProgress="uploadProgress"
						@fileUpload="fileUpload"
						:uploadId="uploadId"
						@closeModal="addnewfile = false"
						@deleteId="uploadId = ''"
						@showThumbnail="showThumbnail"
						:uploadedFilesize="uploadedFilesize"
					/>
				</div>
			</div>

			<hr />
			<div class="d-flex justify-content-between align-items-center px-3 pb-3">
				<div>
					<OButton
						class="p1-15"
						type="add"
						text="Thumbnail"
						@clicked="thumbnailPresent = true"
						:disabled="
							(fileData.assetThumbnail && fileData.assetThumbnail != '') ||
							thumbnailPresent ||
							uploadProgress > 0
						"
					/>
				</div>
				<div class="d-flex align-items-center">
					<OButton text="Cancel" class="p1-15" @clicked="cancelVideo" />
					<PButton
						widthClass="button-width"
						:loading="showLoader"
						@clicked="processVideo"
						class="ml-2 p1-15"
						text="Upload"
						:disabled="
							(uploadProgress != 100 && uploadProgress > 0) ||
							uploadProgress == 100
						"
					/>
				</div>
			</div>
		</b-overlay>
	</b-modal>
</template>
<script>
import Files from "@/views/asset-bank/components/Files.vue";
import { mapGetters } from "vuex";
import { eventBus } from "@/utils/eventBus";
import toast from "@/mixins/toast";

import fileUpload from "@/mixins/fileUpload";
import { required, maxLength } from "vuelidate/lib/validators";

import { postAsset } from "@/views/asset-bank/api-client/assets";
import { getBucket } from "@/views/course-creation/api-client/courseInfoAPI";
export default {
	mixins: [fileUpload, toast],
	components: {
		Files,
	},
	props: {
		addnewfile: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		return {
			index: null,
			showLoader: false,
			showSpinner: false,
			thumbnailPresent: false,
			editFile: false,
			showList: false,
			uploadedFileData: {},
			uploadId: "",
			editedIndex: null,
			notificationvisible: true,
			notinumber: 5,
			uploadProgress: 0,
			uploadTime: "",
			showFileList: true,
			fileData: {},
			videoLength: null,
			thumbnailData: {
				fileName: "",
				previewKey: "",
				sourceKey: "",
			},
			uploadedFilesize: 0,
		};
	},
	validations() {
		return {
			fileData: {
				title: {
					required,
					maxLength: maxLength(124),
				},
			},
		};
	},
	computed: {
		...mapGetters("assetVUEX", {
			files: "getUploadedFiles",
		}),
	},
	created() {
		eventBus.$on("indexSelected", (index) => {
			this.index = index;
			this.showSpinner = true;
			this.updateFileData();
		});
	},
	watch: {
		files: {
			handler() {
				this.updateFileData();
			},
			deep: true,
		},
	},

	methods: {
		updateFileData() {
			if (!this.files || !this.files[this.index]) return;
			const selectedFile = this.files[this.index];
			this.showSpinner = false;

			this.fileData = {
				...selectedFile.fileData,
				assetThumbnail: selectedFile.assetThumbnail,
				assetType: "1",
			};
			this.uploadProgress = selectedFile.progress;
			this.uploadTime = selectedFile.timeRemaining;
			this.uploadId = selectedFile.id;
			this.uploadedFilesize = this.fileData.file.size;
		},
		showThumbnail(file) {
			this.thumbnailData.sourceKey = file.sourceKey;
			this.thumbnailData.previewKey = file.previewKey;
			this.thumbnailPresent = false;
		},
		fileUpload(file) {
			this.uploadProgress = 0;
			this.uploadedFileData = file;

			this.fileData.file = file.sourceKey;
			if (file.name) {
				this.fileData.asset = file.name;
			} else {
				this.fileData.asset = file.fileName;
			}
		},
		async processVideo() {
			this.fileData.asset = this.uploadedFileData.fileName;
			try {
				this.showLoader = true;
				this.isVideoPresent = true;
				this.videoLength = this.uploadedFileData.videoLength;
				const response = await getBucket();
				if (response.status === 200) {
					this.$store.commit("assetVUEX/GET_FILE_DATA", this.fileData);
					this.$store.dispatch("assetVUEX/addUploadedFile", {
						fileName: this.uploadedFileData.fileName,
						videoLength: this.uploadedFileData.videoLength,
						previewKey: this.uploadedFileData.previewKey,
						fileSize: this.uploadedFileData.size,
						sourceKey: this.uploadedFileData.sourceKey,
						fileData: this.fileData,
						assetThumbnail:
							this.fileData.assetThumbnail || this.thumbnailData.previewKey,
					});

					const fileIndex = this.files.length - 1;
					this.calculateHash(
						this.uploadedFileData.files,
						response.data.data,
						fileIndex
					);
				}
			} catch (error) {
				console.error(error);
				this.showLoader = false;
			}
		},
		cancelVideo() {
			this.$emit("close");
			this.showList = true;
			this.$store.commit(
				"assetVUEX/REMOVE_COMPLETED_FILE_USING_TEMP_ID",
				this.files[this.index].fileData.tempId
			);
		},

		async saveVideoAsset(bucketPath) {
			try {
				const formData = new FormData();
				formData.append("title", this.fileData.title);
				formData.append("assetType", 1);
				formData.append("durationInSec", Math.floor(this.videoLength));
				formData.append("assetThumbnail", this.thumbnailData.sourceKey);
				formData.append("assetPath", bucketPath);
				formData.append("tags", JSON.stringify(this.fileData.tags));
				formData.append("assetLibrary", "true");

				const response = await postAsset(formData);
				if (response.status === 200) {
					this.$nextTick(() => {
						this.successToast("Asset added successfully!");
					});

					this.$emit("close");
					// eventBus.$emit("assetUploadSuccess");
					eventBus.$emit("uploadComplete");
				} else {
					this.showLoader = false;
					this.showSpinner = false;
				}
			} catch (error) {
				this.showLoader = false;
				console.log(error);
				this.showSpinner = false;
			}
		},
	},
};
</script>
<style>
.assetbank-modal-height {
	min-height: auto;
	max-height: calc(100vh - 238px);
	overflow: auto;
}
</style>
